<template>
  <v-container class="pa-0">
    <v-row class="">
      <v-col :style="{ 'padding-left': padding }">
        <v-card class="mx-auto mt-10 pa-2" max-width="700px">
          <v-col>
            <div class="text-center">
              <h2 class="title-class my-2">Crear nuevo permiso</h2>
            </div>
            <v-form @submit.prevent="submitForm" ref="form" v-model="valid">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mx-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-text-field
                name="nombrePermiso"
                v-model="scheduleName"
                outlined
                dense
                :rules="rules"
                label="Nombre del permiso"
              />

              <v-autocomplete
                :label="$tc('schedules.holidaysGroup')"
                outlined
                name="feriados"
                v-model="holiday"
                :items="holidays"
                item-text="name"
                item-value="id"
                multiple
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index <= 2">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text text-caption">
                    (+ {{ holidays.length - 3 }} )
                  </span>
                </template>
              </v-autocomplete>
              <v-alert
                v-if="showLimitAlert"
                type="warning"
                dense
                outlined
                @input="showLimitAlert = false"
              >
                {{ $tc("gestionEmpleados.OnlyUpTo300Employees") }}
              </v-alert>
              <v-autocomplete
                :label="$tc('schedules.employees')"
                name="empleados"
                v-model="employee"
                outlined
                :items="employeesWithSelectAll"
                multiple
                item-value="empId"
                item-text="fullName"
                :filter="customFilter"
                :search-input.sync="searchEmployee"
              >
                <template v-slot:item="{ item }">
                  <v-list-item @click.stop="toggleItem(item)">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="isSelected(item)"
                        :indeterminate="isIndeterminate(item)"
                        dense
                        hide-details
                        readonly
                      />
                    </v-list-item-action>
                    <v-list-item-content class="ml-n3">
                      <v-list-item-title>{{
                        item.empId === "all"
                          ? item.fullName
                          : item.fullName + " (" + item.file + ")"
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 2">
                    <span>{{
                      item.empId === "all"
                        ? item.fullName
                        : item.fullName + " (" + item.file + ")"
                    }}</span>
                  </v-chip>
                  <span v-if="index === 2" class="grey--text text-caption">
                    (+ {{ employee.length - 2 }} )
                  </span>
                </template>
              </v-autocomplete>
              <div class="d-flex justify-space-between">
                <v-btn class="bt-exit" @click="reset">{{
                  $tc("editRegistrations.clean")
                }}</v-btn>
                <v-btn type="submit" class="bt-acept">
                  {{ $tc("editRegistrations.acept") }}</v-btn
                >
              </div>
            </v-form>
          </v-col>
        </v-card>
      </v-col>
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
    </v-row>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-container>
</template>
<script>
import schedules from "@/store/permisosDeAcceso/accessPermissions";
import Form from "@/components/Complement/Form.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import holidays from "@/store/horarios/holidays";
import Loader from "@/components/Complement/Loader.vue";

export default {
  components: { Form, Snackbar, Loader },

  data() {
    return {
      alert: false,
      color: "",
      textAlert: "",
      valid: true,
      error: false,
      alertValidate: "",
      slider: {
        label: { from: "09:00", to: "18:00" },
        value: [54, 108],
        min: 0,
        max: 143,
      },
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      rulesTime: [
        (v) => !!v || this.$tc("editRegistrations.requerid"),
        this.validateTimeDifferenceRule,
      ],
      schedule: [
        this.$tc("schedules.weeklySchedule"),
        this.$tc("schedules.rotatingSchedule"),
      ],
      typeSchedule: null,
      employee: [],
      holiday: [],
      scheduleName: "",
      nonLaborRotation: null,
      jobRotation: null,
      isLoading: true,
      searchEmployee: "",
      maxEmployees: 300,
      showLimitAlert: false,
      order: "apellido",
    };
  },
  mounted() {
    this.$store
      .dispatch("employees/getEmployees", {
        photo: false,
        order: this.order,
        soloActivos: true,
      })
      .then(() => {
        this.isLoading = false;
      });
    holidays.dispatch("getHolidays");
    this.checkViewportWidth();
  },

  computed: {
    padding() {
      return schedules.state.paddingNav;
    },
    employees() {
      return this.$store.state.employees.employees;
    },
    employeesWithSelectAll() {
      return [
        { empId: "all", fullName: "Seleccionar todos", file: "" },
        ...this.employees,
      ];
    },
    holidays() {
      return holidays.state.holidays;
    },
  },

  methods: {
    isSelected(item) {
      if (item.empId === "all") {
        return this.employee.length === this.employees.length;
      }

      return this.employee.includes(item.empId);
    },

    isIndeterminate(item) {
      if (item.empId !== "all") return false;

      return (
        this.employee.length > 0 && this.employee.length < this.employees.length
      );
    },

    toggleItem(item) {
      if (item.empId === "all") {
        const isAllSelected = this.employee.length > 0;

        if (isAllSelected) {
          this.employee = [];
          this.showLimitAlert = false;
        } else {
          const allIds = this.employees.map((e) => e.empId);

          if (allIds.length > this.maxEmployees) {
            this.employee = allIds.slice(0, this.maxEmployees);
            this.showLimitAlert = true;
          } else {
            this.employee = allIds;
            this.showLimitAlert = false;
          }
        }

        this.searchEmployee = "";
        return;
      }

      const exists = this.employee.includes(item.empId);

      if (exists) {
        this.employee = this.employee.filter((id) => id !== item.empId);
        this.showLimitAlert = false;
      } else {
        if (this.employee.length >= this.maxEmployees) {
          this.showLimitAlert = true;
          return;
        }

        this.employee = [...this.employee, item.empId];

        if (this.employee.length === this.maxEmployees) {
          this.showLimitAlert = true;
        } else {
          this.showLimitAlert = false;
        }
      }

      this.searchEmployee = "";
    },

    customFilter(item, queryText) {
      const search = queryText.toLowerCase();

      return (
        item.fullName?.toLowerCase().includes(search) ||
        item.file?.toString().toLowerCase().includes(search)
      );
    },

    checkViewportWidth() {
      const windowWidth = window.innerWidth;
      if (windowWidth < 959) {
        schedules.commit("setPaddingNav", "60px");
      }
    },
    validateTimeDifferenceRule() {
      const minTimeDifferenceInMinutes = 60;
      const minTimeDifferenceInSliderUnits = minTimeDifferenceInMinutes / 10;

      const timeDifferenceInSliderUnits =
        this.slider.value[1] - this.slider.value[0];

      return (
        timeDifferenceInSliderUnits >= minTimeDifferenceInSliderUnits ||
        this.$tc("schedules.minTimeDifferenceError")
      );
    },
    formatTime(value) {
      const hours = Math.floor(value / 6);
      const minutes = (value % 6) * 10;
      const formattedHours = hours.toString().padStart(2, "0");
      const formattedMinutes = minutes.toString().padStart(2, "0");
      return `${formattedHours}:${formattedMinutes}`;
    },
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.saveForm(itemsComplete);
    },
    handleSliderChange(item) {
      const value = 10;

      this.slider.value[0] = item[0] * value;
      this.slider.value[1] = item[1] * value;
    },

    saveForm(items) {
      this.isLoading = true;
      let payload = {
        nombre: items.nombrePermiso,
        grupoFeriados: items.feriados.replace(/\s/g, "").split(",").map(Number),
        listaEmpleados: items.empleados
          .replace(/\s/g, "")
          .split(",")
          .map(Number),
      };

      schedules.commit("setNewPermissionAsistent", payload);
      schedules
        .dispatch("newAllPermissionAsistent")
        .then(() => {
          this.isLoading = false;
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addScheduleAlert");
          this.showLimitAlert = false;
        })
        .catch((e) => {
          this.isLoading = false;
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.reset();
    },

    reset() {
      this.showLimitAlert = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.slider.value = [54, 108];
      this.typeSchedule = null;
      this.employee = [];
      this.holiday = [];
      this.scheduleName = "";
      this.nonLaborRotation = null;
      this.jobRotation = null;
      this.alert = false;
    },
  },
};
</script>
<style scoped>
.title-class {
  color: #586271;
  font-weight: lighter !important;
  margin-bottom: 20px !important;
  text-shadow: 1px 0px #384b6d;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.v-slider__thumb-label p {
  font-size: 10px;
  margin-bottom: 0px;
}
.container {
  padding: 0;
}
</style>
